import { faInfo } from '@fortawesome/pro-solid-svg-icons';
import React from 'react';
import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import HesSpinner from '../../../../../../../../components/loadingOverlay/hesSpinner';
import { useGetStudentFileMutation } from '../../../../../../../../features/authentication/assignmentApislice';

function StudentUploadedFilesModal(props) {
  const [studentFiles, setStudentFiles] = useState([]);
  const [downloadStudentFile] = useGetStudentFileMutation();

  useEffect(() => {
    if (props.studentFilesData?.files) {
      setStudentFiles(
        props.studentFilesData.files.map((file) => {
          return { ...file, isDownloading: false, hasError: false };
        })
      );
    }
  }, [props]);

  async function handleDownloadStudentFile(file, index) {
    var fileStatusElement = document.getElementById(`studentFileStatus_${index}`);
    var fileErrorElement = document.getElementById(`studentFileError_${index}`);
    try {
      fileStatusElement.style.display = 'flex';
      fileErrorElement.style.display = 'none';

      const fileResponse = await downloadStudentFile(file).unwrap();
      const downloadLink = document.createElement('a');
      downloadLink.href = fileResponse;
      downloadLink.download = file.fileName;
      downloadLink.click();
      fileStatusElement.style.display = 'none';
    } catch (ex) {
      fileStatusElement.style.display = 'none';
      fileErrorElement.style.display = 'block';
    }
  }

  return (
    <Modal show={props.show} onHide={props.onHide} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title id="retakeResultsModal">
          <h1>Student Uploaded Files</h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex flex-column">
          <span>
            Assignment: <b>{props.assignmentName}</b>
          </span>
          <span>
            Student: <b>{!props.isFerpa ? 'hidden' : props.studentFilesData?.studentName}</b>
          </span>

          <div className="custom-table my-3">
            <table className="table">
              <thead>
                <tr>
                  <th>Description</th>
                  <th>Filename</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {studentFiles &&
                  studentFiles.map((item, index) => {
                    return (
                      <tr key={`studentFile_${index}`}>
                        <td>{item.description}</td>
                        <td>
                          <a
                            onClick={() => {
                              handleDownloadStudentFile(item, index);
                            }}
                            className="link-secondary">
                            {item.fileName}
                          </a>
                        </td>
                        <td style={{ width: '20%' }}>
                          <div
                            id={`studentFileStatus_${index}`}
                            className="flex-row justify-content-center align-items-center"
                            style={{ display: 'none', height: '60%' }}>
                            <HesSpinner />
                            <div className="ms-2">Getting file...</div>
                          </div>
                          <div
                            id={`studentFileError_${index}`}
                            style={{ color: '#F84646', display: 'none' }}>
                            Could not get file
                          </div>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>

          <div className="d-flex flex-row align-items-center">
            <div
              className="d-flex align-items-center justify-content-center me-3"
              style={{
                background: '#D5F2FF',
                borderRadius: '35px',
                height: '36px',
                width: '40px',
                fontSize: '1.25em'
              }}>
              <FontAwesomeIcon icon={faInfo} color="#63D0FF" />
            </div>
            <div>
              You can click on the filename to view it in your browser or download it to your device
              (depending on the file type and your device settings).
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

StudentUploadedFilesModal.propTypes = {
  studentFilesData: PropTypes.any,
  assignmentName: PropTypes.string,
  show: PropTypes.func,
  onHide: PropTypes.any,
  isFerpa: PropTypes.bool
};

export default StudentUploadedFilesModal;
